exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#myApp,.app-theme-light{height:100%;background-color:#f4f7fa}.mask{height:100%;position:absolute;top:0;left:0;width:100%}", ""]);

// exports
